export default __webpack_public_path__ + "static/media/GLMOil-10000-Front500x500.9657a13d.png";